import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useUserStatus } from '../../Hooks/useUserStatus';
// import Navbar from './components/Navbar';
import { Box, styled, useMediaQuery, useTheme } from '@mui/material';
import ModalValidationEmail from './components/ModalValidationEmail';
import { useConfig } from '../../Hooks/useConfig';
import Sidebar from '../Layout/components/Sidebar';
import useUsersFacade from '../../store/profile/useUsersFacade';
import { getCookie, setCookie } from '../../utils/cookies';
import BlankPageError from '../GetAnswerBox/components/ErrorBoundaryFallback2';
import FallbackUI from '../Layout/components/FallbackUI';
import LayoutWithBanner from '../LayoutWithBanner';
import ChristmasBanner from '../ChristmasBanner';
import Navbar from '../LayoutPanel/components/Navbar/index';
import {
  PageTitleProvider,
  usePageTitleContext,
} from '../../context/PageTitleContext';
import useCreditWarningStore from '../../store/credits/useCreditWarningStore';

const MainContainer = styled('div')(({ theme, open }) => ({
  width: 'calc(100% - 234px)',
  marginRight: theme.direction !== 'ltr' ? 'auto' : null,
  marginLeft: theme.direction !== 'rtl' ? 'auto' : null,
  // minHeight: 'calc(100vh)',
  marginBottom: theme.spacing(0),
  // backgroundColor: 'red',
  // background: 'yellow',
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),

  // paddingRight: theme.spacing(2),
  [theme.breakpoints.down('md')]: {
    paddingLeft: theme.spacing(0),
    paddingRight: theme.spacing(0),
    width: '100%',
  },
  ...(!open && {
    [theme.breakpoints.up('md')]: {
      width: 'calc(100% - 72px) !important',
    },
  }),
}));

const ContentMain = styled('main')(({ theme, open, isHome }) => ({
  display: 'flex',
  flexDirection: 'column',
  padding: isHome ? theme.spacing(0, 0) : theme.spacing(0, 4),
  margin: theme.spacing(2.25, -2, 0, 4),
  background: theme.palette.mode === 'dark' ? '#222' : '#F9FCFF',
  height: 'calc(100vh - 34px)',
  borderRadius: theme.spacing(4),
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(0, 0),
    height: 'auto !important',
    minHeight: 'calc(100vh - 34px)',
    overflow: 'hidden',
    marginLeft: theme.spacing(0),
    marginBottom: theme.spacing(0),
    margin: theme.spacing(1, 0, 0, 0),
  },
}));

const LayoutContent = ({ children }) => {
  const { loginState, isLogin } = useUserStatus();
  const { show_upgrade_modal, baseDomain } = useConfig();
  const theme = useTheme();
  const [openUpgrade, setOpenUpgrade] = useState(false);
  const [openDrawer, setOpenDrawer] = useState(
    getCookie('sidebarOpen') === 'true'
  );
  const { userInfo, loading } = useUsersFacade();
  const mdUp = useMediaQuery(theme.breakpoints.up('md'));
  const smDown = useMediaQuery(theme.breakpoints.down('sm'));
  const mdDown = useMediaQuery(theme.breakpoints.down('md'));
  const lgDown = useMediaQuery(theme.breakpoints.down('lg'));
  const xlDown = useMediaQuery(theme.breakpoints.down('xl'));
  const { exampleListCount, setIsPlayground, pageTitle } =
    usePageTitleContext();
  const { pathname } = useLocation();
  const isHome = pathname === '/';
  const { openModal } = useCreditWarningStore();

  useEffect(() => {
    if (userInfo) {
      const creditsRemaining = (userInfo?.credits ?? 0) + (userInfo?.extra_credits ?? 0);
      if (creditsRemaining < 0) {
        const hasShown = getCookie('credit_warning_playground_shown');
        if (!hasShown) {
          openModal();
          setCookie('credit_warning_playground_shown', 'true', 24 * 3600, baseDomain);
        }
      }
    }
  }, [userInfo, openModal, baseDomain]);

  const handleOpenUpgrade = () => setOpenUpgrade(true);

  // Set isPlayground to true for playground routes
  useEffect(() => {
    setIsPlayground(true);

    // Cleanup: reset when unmounting
    return () => {
      setIsPlayground(false);
    };
  }, [setIsPlayground]);

  useEffect(() => {
    var timeOutUpgrade;

    if (isLogin()) {
      if (!show_upgrade_modal) {
        timeOutUpgrade = setTimeout(() => {
          handleOpenUpgrade();
          localStorage.setItem('show_upgrade_modal', true);
        }, 300000);
      }
    }

    return () => clearTimeout(timeOutUpgrade);
  }, [loginState]);

  const handleDrawerOpen = () => {
    setOpenDrawer(true);
    setCookie('sidebarOpen', 'true', 34560000, baseDomain);
  };

  const handleDrawerClose = () => {
    setOpenDrawer(false);
    setCookie('sidebarOpen', 'false', 34560000, baseDomain);
  };

  useEffect(() => {
    const sidebarOpen = getCookie('sidebarOpen');
    if (!sidebarOpen) {
      handleDrawerOpen();
    } else {
      const shouldOpen = sidebarOpen === 'true';
      if (mdUp || shouldOpen) {
        setOpenDrawer(shouldOpen);
      }
    }
  }, [mdUp]);

  return (
    <>
      {/* <ChristmasBanner isSidebarOpen={openDrawer} /> */}

      <LayoutWithBanner>
        <MainContainer open={openDrawer}>
          {!mdUp && (
            <Navbar
              handleDrawerOpen={handleDrawerOpen}
              userInfoData={userInfo}
            />
          )}
          {/* <Navbar
          handleDrawerClose={handleDrawerClose}
          handleDrawerOpen={handleDrawerOpen}
          open={openDrawer}
          userInfoData={userInfo}
        /> */}

          {/* {userInfo?.email_verified_at === null ? (
          <ModalValidationEmail
            open={userInfo.email_verified_at === null}
            email={userInfo.email}
          />
        ) : null} */}
          <Sidebar
            handleDrawerClose={handleDrawerClose}
            handleDrawerOpen={handleDrawerOpen}
            open={openDrawer}
            userInfoData={userInfo}
          />
          {/* {children} */}
          {/* <ContentMain> */}

          <ContentMain exampleListCount={exampleListCount} isHome={isHome}>
            {loginState && !loading && !userInfo ? (
              <FallbackUI />
            ) : (
              <Box
                sx={{
                  flex: 1,
                  overflowY: 'auto',
                  height: '100%',
                  width: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                {children}
              </Box>
            )}
          </ContentMain>
          {/* </ContentMain> */}
          {/* {!loading && !userInfo ? <BlankPageError /> : <>{children}</>} */}
        </MainContainer>
      </LayoutWithBanner>
    </>
  );
};

const Layout = ({ children }) => {
  return (
    <PageTitleProvider>
      <LayoutContent>{children}</LayoutContent>
    </PageTitleProvider>
  );
};
export default Layout;
